import { useMutation } from "./useApi";
import { approvalRequests } from "../api/approvalRequests.service";

export function useLock() {
  return useMutation((id: string) => approvalRequests.lock(id));
}

export function useUnlock() {
  return useMutation((id: string) => approvalRequests.unlock(id));
}

export function useUpdateContentOutput() {
  return useMutation((id: string, contentOutput: string) =>
    approvalRequests.updateContentOutput(id, contentOutput),
  );
}
